import type { AmountPerVehicleTypeEntity } from './AmountPerVehicleTypeEntity'

export class BranchSegmentEntity {
  from?: number
  to?: number
  amount?: number
  amountPerVehicleTypes?: AmountPerVehicleTypeEntity[]
}
